export default __webpack_public_path__ + "static/media/FortisHeader4.848c2ff9.png";